/* eslint-disable react-hooks/exhaustive-deps */
import { useTranslation } from "react-i18next";
import AllResolveComplaint from "../../corporate/grievance/Home/AllResolveComplaint";
import AllResolveComplaintComponent from "../../corporate/vigilance/Home/AllResolveComplaint";
import { useEffect } from "react";

const Complaints = ({ select, setSelect }: any) => {
    const { t } = useTranslation('common');
    const category: any[] = window.location.pathname?.includes?.("grievance-complaints") ? [
        { name: t("grievance.home.banner.status.pending"), key: "Pending_Review" },
        { name: t("grievance.home.banner.status.in_progress"), key: "Pending_Verification" },
        { name: t("grievance.home.banner.status.in_investigation"), key: "Under_Investigation" },
        { name: t("grievance.home.banner.status.refer_b"), key: "Refer_To_Customer" },
        { name: t("grievance.home.banner.status.resolved"), key: "Resolved" }
    ] : [
        { name: t("vigilance.home.banner.status.pending_review"), key: "Pending_Review" },
        { name: t("vigilance.home.banner.status.under_investigation"), key: "Pending_Verification" },
        // { name: t("vigilance.home.banner.status.action_taken"), key: "Under_Investigation" },
        { name: t("vigilance.home.banner.status.resolved"), key: "Resolved" }
    ]

    useEffect(() => {
        if(window.location.pathname?.includes?.("vigilance-complaints") && select === "Refer_To_Customer") {
            setSelect("Pending_Review")
        }
    }, [window.location.pathname])

    return (
        <div className="flex flex-col w-full">
            <div className="flex flex-col gap-[5px] w-full pb-[20px] px-[15px] md:p-[30px] xlx:p-[35px] border-b border-primary border-opacity-[0.2]">
                <h3 className="text-primaryText dark:text-white font-semibold">{window.location.pathname?.includes?.("grievance-complaints") ? t("profile.tabs.grievance_complaint") : t("profile.tabs.vigilance_complaint")}</h3>
                <h6 className="text-blackDull dark:text-textBlackDull font-medium xsm:max-w-max max-w-[200px]">{window.location.pathname?.includes?.("grievance-complaints") ? t("profile.grievance_desc") : t("profile.vigilance_desc")}</h6>
            </div>
            <div className="flex items-center gap-[8px] w-full border-b border-primary border-opacity-[0.2] px-[15px] md:px-[30px] xlx:px-[35px] overflow-x-auto">
                {Array.isArray(category) && category?.map((item: any, index: number) => (
                    <button key={index} className={`${select === item?.key ? "text-primaryText dark:text-white border-b-[2px] border-primary" : "text-blackDull dark:text-textBlackDull focus:text-primaryText hover:text-primaryText dark:focus:text-white dark:hover:text-white focus:underline hover:underline border-b-[2px] border-transparent"} text-sm font-medium py-[6px] px-[16px] whitespace-nowrap`} onClick={() => setSelect(item?.key)}>{item?.name}</button>
                ))}
            </div>

            <div className="w-full h-full flex items-center justify-center py-[20px] px-[15px] md:p-[30px] xlx:px-[35px]">
                {window.location.pathname?.includes?.("grievance-complaints") ? <AllResolveComplaint type="passenger" select={select} /> : <AllResolveComplaintComponent type="passenger" select={select} />}
            </div>
        </div>
    );
};

export default Complaints;